/* src/app/layouts/orto-layout/orto-layout.component.scss */
/*# sourceMappingURL=orto-layout.component.css.map */
